import React, { useEffect, useState, memo } from "react"
import "./PRSRecordStatus.scss"

export function getRecorStatus(data) {
  if (data) {
    if (data.is_cancelled === true) {
      return "Upload Cancelled"
    } else if (data.is_processing === true) {
      return "Uploading"
    } else if (data.is_queued === true) {
      return "Not Yet Started"
    } else if (data.upload_failed === true) {
      return "Failed"
    } else if (data.upload_report?.recordStatus) {
      return data.upload_report.recordStatus
    } else return "Not Yet Started"
  }
}
const PRSRecordStatus = (props) => {
  const [iconName, setIconName] = useState("")
  const [status, setStatus] = useState("Not Yet Started")

  useEffect(() => {
    setStatus(getRecorStatus(props.data))
  }, [props.data])

  useEffect(() => {
    switch (status) {
      case "Uploading":
        setIconName("far fa-redo")
        break
      case "Not Yet Started":
        setIconName("fas fa-clock")
        break
      case "Failed":
        setIconName("fas fa-minus-circle")
        break
      case "Upload Cancelled":
        setIconName("far fa-ban")
        break
      case "Release Cancelled":
        setIconName("far fa-ban")
        break
      default:
        setIconName("fas fa-check-circle")
    }
  }, [status])

  const getColor = (variant) => {
    switch (variant) {
      case "Not Yet Started":
      case "Uploading":
        return "prs-record-info"
      case "Failed":
      case "Upload Cancelled":
      case "Release Cancelled":
        return "prs-record-error"
      default:
        return "prs-record-success"
    }
  }

  return (
    <div className="prs-record-status-container">
      <i
        className={`${iconName} ${status === "Uploading" ? "animation-mixin" : "no-animation-mixin"} ${getColor(
          status
        )} prs-record-status-icon`}
      />
      {status}
      {props.data.receipt_url && (
        <a
          href={props.data.receipt_url}
          target="_blank"
          className="view-receipt-link"
        >
          View Receipt
        </a>
      )}
    </div>
  )
}

export default memo(PRSRecordStatus)
